import { ButtonIcon } from "@/lib/main";
import { CSSProperties, FormEvent, useState } from "react";

type Props = {
  onSearchSubmit?: (query: string) => void;
  searchBarPlaceholder?: string;
  fullWidth?: boolean;
};

export default function NavbarSearchBar({
  onSearchSubmit,
  searchBarPlaceholder,
  fullWidth,
}: Props) {
  const [query, setQuery] = useState("");
  const [isFocused, setIsFocused] = useState(false);

  const handleSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSearchSubmit?.(query);
  };

  const formStyle: CSSProperties = {
    display: "flex",
    alignItems: "center",
    gap: "var(--spacing-xs)",
    width: fullWidth ? "100%" : undefined,
  };

  const inputStyle: CSSProperties = {
    backgroundColor: "var(--color-background-frame)",
    border: `var(--border-width-sm) solid var(--color-border-${isFocused ? "focus" : "quaternary"})`,
    borderRadius: "var(--border-radius-sm)",
    color:
      query === "" ? "var(--color-text-tertiary)" : "var(--color-text-primary)",
    fontSize: "var(--font-size-sm)",
    height: "2.25rem",
    padding: "0 var(--spacing-md)",
    width: fullWidth ? "100%" : "14rem",
    outline: "none",
  };

  return (
    <form onSubmit={handleSubmit} style={formStyle}>
      <input
        aria-label={searchBarPlaceholder ?? "Search"}
        onBlur={() => setIsFocused(false)}
        onChange={(e) => setQuery(e.target.value)}
        onFocus={() => setIsFocused(true)}
        placeholder={searchBarPlaceholder ?? "Search..."}
        style={inputStyle}
        type="search"
        value={query}
      />
      <ButtonIcon iconName="search" />
    </form>
  );
}
